import { fromNow, formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePlaceAvailability } from '../_load/PlaceAvailabilityLoader'
import AvailabilityStatusTag from '../../_shared/AvailabilityStatusTag'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Panel from '../../../../packages/kiti/components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import { SmallText, Text } from '../../../../components/presentation/Text'

// Backend currently only exposes the *last* status change (origin + timestamp) on
// `Place`, not a full change log — so this renders a single, most-recent entry today.
// It's built so a future history/audit endpoint (e.g. a list of past changes) can be
// dropped in here as more `Panel` entries without reshaping this tab.
const History = () => {
  const { t } = useTranslation('availability')
  const place = usePlaceAvailability()
  const lock = place.locks?.[0]

  if (!place.availabilityStatusChangedAt) {
    return <SmallText color="dark3">{t('history.empty')}</SmallText>
  }

  return (
    <>
      <Separator weight={2} />

      <Panel bgColor="light1" noMargin>
        <FlexGrid justify="space-between" align="center">
          <FlexCol flex={1}>
            <Text bold color="dark2">
              {t('history.lastChange')}
            </Text>
            <SmallText color="dark3">
              {t(`origin.${place.availabilityStatusOrigin}`)} ·{' '}
              {formatDate('DD/MM/YYYY HH:mm')(place.availabilityStatusChangedAt)} (
              {fromNow(place.availabilityStatusChangedAt)})
            </SmallText>
            {lock?.reason && <SmallText color="dark3">{lock.reason}</SmallText>}
            {lock?.createdBy?.name && <SmallText color="dark3">{lock.createdBy.name}</SmallText>}
          </FlexCol>

          <FlexCol>
            <AvailabilityStatusTag status={place.availabilityStatus} />
          </FlexCol>
        </FlexGrid>
      </Panel>
    </>
  )
}

export default History
